import React, { useEffect, useState } from "react";
import { includes } from "ramda";
import makeStyles from "@mui/styles/makeStyles";
import { isAdminView } from "../util";
import { notBlank } from "../../../util/ext";
import { Link } from "react-router-dom";

import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useCreatorContext } from "../../CreatorContext";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(3),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  name: {
    color: theme.palette.primary.brandPrimary,
  },
}));

const ModuleCard = props => {
  const { module, view, LinkProps } = props;
  const classes = useStyles();
  const context = useCreatorContext();

  const [showId, setShowId] = useState(false);
  useEffect(() => {
    if (notBlank(view)) {
      setShowId(isAdminView(view));
    }
  }, [view]);

  return (
    <Container className={classes.root} maxWidth={false}>
      <Avatar
        variant="rounded"
        alt={module.name}
        src={
          includes(module.id, context.updatedThumbnails)
            ? `${module.thumbnailUrl}&tc${Date.now()}`
            : module.thumbnailUrl
        }
        className={classes.thumbnail}
      />
      <div className={classes.main}>
        <Link {...LinkProps}>
          <Typography className={classes.name} noWrap={!isAdminView(view)}>
            {module.name}
          </Typography>
        </Link>

        {showId && <Typography>{module.id}</Typography>}
      </div>
    </Container>
  );
};

export default ModuleCard;
